import configuration from "@intlayer/config/built";
import { fetcher } from "../fetcher.mjs";
const getNewsletterAPI = (authAPIOptions = {}, intlayerConfig) => {
  const backendURL = intlayerConfig?.editor?.backendURL ?? configuration.editor?.backendURL;
  if (!backendURL) {
    throw new Error(
      "Backend URL is not defined in the Intlayer configuration."
    );
  }
  const NEWSLETTER_API_ROUTE = `${backendURL}/api/newsletter`;
  const subscribeToNewsletter = async (body, otherOptions = {}) => await fetcher(
    `${NEWSLETTER_API_ROUTE}/subscribe`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const unsubscribeFromNewsletter = async (body, otherOptions = {}) => await fetcher(
    `${NEWSLETTER_API_ROUTE}/unsubscribe`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const getNewsletterStatus = async (otherOptions = {}) => await fetcher(
    `${NEWSLETTER_API_ROUTE}/status`,
    authAPIOptions,
    otherOptions,
    {
      method: "GET"
    }
  );
  return {
    subscribeToNewsletter,
    unsubscribeFromNewsletter,
    getNewsletterStatus
  };
};
export {
  getNewsletterAPI
};
//# sourceMappingURL=newsletter.mjs.map